import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import Hero from "../components/Hero";
import AboutUs from "../components/AboutUs";
import WhatWeDo from "../components/WhatWeDo";
import JobCards from "../components/JobCards";
import Benefits from "../components/Benefits";
import ApplicationForm from "../components/ApplicationForm";
import Footer from "../components/Footer";
import ScrollProgress from "../components/ScrollProgress";
import StickyMobileCTA from "../components/StickyMobileCTA";

export default function LandingPage() {
    const location = useLocation();

    useEffect(() => {
        document.title = "Karriere bei Möbus Umweltschutz GmbH";
        const meta = document.querySelector('meta[name="description"]');
        if (meta) {
            meta.setAttribute(
                "content",
                "Bewirb dich bei der Möbus Umweltschutz GmbH in Neustadt. Wir suchen Verstärkung in Marketing, Organisation, Montage, Elektrik und freuen uns auch über Initiativbewerbungen."
            );
        }
    }, []);

    useEffect(() => {
        if (location.hash) {
            const id = location.hash.replace("#", "");
            const el = document.getElementById(id);
            if (el) setTimeout(() => window.scrollTo({ top: el.offsetTop - 72, behavior: "smooth" }), 100);
        }
    }, [location]);

    return (
        <div className="min-h-screen bg-white pb-20 md:pb-0">
            <ScrollProgress />
            <Header />
            <Hero />
            <AboutUs />
            <WhatWeDo />
            <Benefits />
            <JobCards />
            <ApplicationForm />
            <Footer />
            <StickyMobileCTA />
        </div>
    );
}
